/*
 * IMPORTS
 */
import React from 'react' // Npm: react.js library.
import PropTypes from 'prop-types' // Npm: prop-types library.
import _ from 'underscore' // Npm: underscore library.
import NaturalCompare from 'natural-compare' // Npm: natural-compare library.
import { useQuery } from '@apollo/client' // Npm: Apollo client.


/*
 * PACKAGES
 */
import { MemoizedSelect } from 'components/MemoizedInput'


/*
 * GRAPHS
 */
import CustomerReadQuery from './__query__/index.customer.read.query'


/*
 * OBJECTS
 */
const Index = ({ onChange, customerType, ...props }) => {
  // Const assignment.
  const _skipDifference = 10000

  // Hook assignment.
  const _QueryCustomerRead = useQuery(CustomerReadQuery, { 'variables': { customerType, 'take': _skipDifference, 'skip': 0 }, 'fetchPolicy': Object.React.App.fetchPolicy, 'pollInterval': Object.React.App.pollInterval })

  // Memoized sorted options.
  const _customerOptions = React.useMemo(() =>
    _.compact(
      _QueryCustomerRead?.data?.CustomerRead?.map?.(j =>
        'READ_SUCCESSFUL' === j.status ? `${j.displayName} (${j.id})` : void 0
      ))
      ?.sort((a, b) => NaturalCompare(a, b))
    , [_QueryCustomerRead?.data?.CustomerRead])

  // Return component.
  return (
    <MemoizedSelect
      onChange={onChange}
      options={_customerOptions}
      isRequired={true}
      {...props}
    />
  )
}


/*
 * PROPTYPES
 */
Index.propTypes = {
  'onChange': PropTypes.func.isRequired,
  'customerType': PropTypes.string.isRequired
}


/*
 * EXPORT
 */
export default Index
